import { render, staticRenderFns } from "./pupup.vue?vue&type=template&id=bb35b056&"
import script from "./pupup.vue?vue&type=script&lang=js&"
export * from "./pupup.vue?vue&type=script&lang=js&"
import style0 from "./pupup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports